(() => {
  if (typeof window.iCarsoftNewArrivalInitialize === 'function') {
    window.iCarsoftNewArrivalInitialize(document);
    return;
  }

  const escapeHtml = (value) => String(value || '')
    .replaceAll('&', '&amp;')
    .replaceAll('<', '&lt;')
    .replaceAll('>', '&gt;')
    .replaceAll('"', '&quot;')
    .replaceAll("'", '&#039;');

  const initialize = (root) => {
    if (!root || root.dataset.newdropReady === 'true') return;

    const filters = Array.from(root.querySelectorAll('[data-newdrop-filter]'));
    const cards = Array.from(root.querySelectorAll('[data-newdrop-card]'));
    const empty = root.querySelector('[data-newdrop-empty]');
    const compareTray = root.querySelector('[data-newdrop-compare-tray]');
    const compareCount = root.querySelector('[data-newdrop-compare-count]');
    const compareThumbs = root.querySelector('[data-newdrop-compare-thumbs]');
    const compareOpen = root.querySelector('[data-newdrop-compare-open]');
    const compareClear = root.querySelector('[data-newdrop-compare-clear]');
    const compareModal = root.querySelector('[data-newdrop-compare-modal]');
    const compareClose = root.querySelector('[data-newdrop-compare-close]');
    const compareTable = root.querySelector('[data-newdrop-compare-table]');
    let selectedCompare = [];
    let compareReturnFocus = null;

    if (!filters.length || !cards.length) {
      root.dataset.newdropReady = 'true';
      return;
    }

    const setFilter = (value) => {
      let visibleCount = 0;

      cards.forEach((card) => {
        const visible = value === 'all' || card.dataset.group === value;
        card.hidden = !visible;
        if (visible) visibleCount += 1;
      });

      filters.forEach((filter) => {
        const selected = filter.dataset.newdropFilter === value;
        filter.classList.toggle('is-active', selected);
        filter.setAttribute('aria-pressed', selected ? 'true' : 'false');
      });

      if (empty) empty.hidden = visibleCount !== 0;
    };

    const compareData = (card) => ({
      handle: card.dataset.handle || '',
      title: card.dataset.title || '',
      url: card.dataset.url || '#',
      image: card.dataset.image || '',
      price: card.dataset.price || '',
      series: card.dataset.series || '',
      type: card.dataset.group === 'v4' ? 'V4.0 series' : card.dataset.group === 'cr' ? 'CR professional' : 'New arrival',
      description: card.dataset.description || '',
      highlights: card.dataset.highlights || ''
    });

    const updateCompareTray = () => {
      if (!compareTray || !compareOpen) return;
      compareTray.hidden = selectedCompare.length === 0;
      if (compareCount) compareCount.textContent = String(selectedCompare.length);
      compareOpen.disabled = selectedCompare.length < 2;
      compareOpen.setAttribute('aria-disabled', String(selectedCompare.length < 2));
      if (compareThumbs) {
        compareThumbs.innerHTML = selectedCompare.map((card) => {
          const item = compareData(card);
          return `<span class="newdrop__compare-thumb" title="${escapeHtml(item.title)}">${item.image ? `<img src="${escapeHtml(item.image)}" alt="">` : ''}</span>`;
        }).join('');
      }
    };

    const renderCompareTable = () => {
      if (!compareTable) return;
      const shared = window.ICARSOFT_COMPARE_SPECS;
      const items = selectedCompare.map((card) => {
        const item = compareData(card);
        return shared ? shared.merge(item, 'catalog') : item;
      });
      const header = items.map((item) => `
        <th scope="col">
          <a class="newdrop__compare-product" href="${escapeHtml(item.url)}">
            ${item.image ? `<img src="${escapeHtml(item.image)}" alt="">` : ''}
            <span><strong>${escapeHtml(item.title)}</strong><span>${escapeHtml(item.price)}</span></span>
          </a>
        </th>`).join('');
      const rowDefinitions = shared ? shared.rowsFor('catalog') : [
        ['Series', 'type'],
        ['Designed for', 'series'],
        ['Product summary', 'description'],
        ['Highlights', 'highlights']
      ];
      const rows = rowDefinitions.map(([label, key]) => `
        <tr><th scope="row">${escapeHtml(label)}</th>${items.map((item) => `<td>${escapeHtml(shared ? shared.value(item, key) : (item[key] || '-'))}</td>`).join('')}</tr>`).join('');

      compareTable.innerHTML = `<table class="newdrop__compare-table"><thead><tr><th></th>${header}</tr></thead><tbody>${rows}</tbody></table>`;
    };

    const closeCompare = () => {
      if (!compareModal) return;
      if (typeof compareModal.close === 'function' && compareModal.open) compareModal.close();
      else compareModal.removeAttribute('open');
      if (compareReturnFocus?.focus) compareReturnFocus.focus();
      compareReturnFocus = null;
    };

    const openCompare = () => {
      if (selectedCompare.length < 2 || !compareModal) return;
      compareReturnFocus = document.activeElement;
      renderCompareTable();
      if (typeof compareModal.showModal === 'function') {
        if (!compareModal.open) compareModal.showModal();
      } else {
        compareModal.setAttribute('open', '');
      }
    };

    const clearCompare = () => {
      selectedCompare.forEach((card) => {
        const toggle = card.querySelector('[data-newdrop-compare-toggle]');
        if (toggle) toggle.checked = false;
      });
      selectedCompare = [];
      closeCompare();
      updateCompareTray();
    };

    filters.forEach((filter) => {
      filter.addEventListener('click', () => setFilter(filter.dataset.newdropFilter));
    });

    cards.forEach((card) => {
      const toggle = card.querySelector('[data-newdrop-compare-toggle]');
      if (!toggle) return;
      toggle.addEventListener('change', () => {
        if (toggle.checked) {
          if (selectedCompare.length >= 3) {
            toggle.checked = false;
            window.alert('Choose up to three new arrivals to compare.');
            return;
          }
          if (!selectedCompare.includes(card)) selectedCompare.push(card);
        } else {
          selectedCompare = selectedCompare.filter((selected) => selected !== card);
        }
        updateCompareTray();
      });
    });

    compareOpen?.addEventListener('click', openCompare);
    compareClear?.addEventListener('click', clearCompare);
    compareClose?.addEventListener('click', closeCompare);
    compareModal?.addEventListener('click', (event) => {
      if (event.target === compareModal) closeCompare();
    });
    root.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && compareModal?.hasAttribute('open')) closeCompare();
    });

    root.dataset.newdropReady = 'true';
    setFilter('all');
    updateCompareTray();
  };

  const initializeAll = (scope = document) => {
    scope.querySelectorAll('[data-newdrop-root]').forEach(initialize);
  };

  window.iCarsoftNewArrivalInitialize = initializeAll;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeAll());
  } else {
    initializeAll();
  }

  document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
})();
